import { ISelectItem } from "./ISelectItem";
import ClassUtil from "../../ClassUtil";

/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass('SelectItemData')
export default class SelectItemData<T> implements ISelectItem<T>
{
    public static readonly OnChangedEventName: string = `${ClassUtil.getName(SelectItemData)}.Onchanged`;
    private readonly _eventTarget: cc.EventTarget = new cc.EventTarget();
    public OnChanged(fnOnChange: () => any): SelectItemData<T>
    {
        this._eventTarget.on(SelectItemData.OnChangedEventName, fnOnChange);
        return this;
    }

    @property({ visible: false })
    private _itemId: string = '';
    @property()
    public get ItemId(): string { return this._itemId; }
    public set ItemId(value: string) { this._itemId = value; }

    private _item: T = null;
    public get Item(): T { return this._item; }

    @property({ visible: false })
    private _displayName: string = '';
    @property()
    public get DisplayName(): string { return this._displayName; }
    public set DisplayName(value: string)
    {
        if (value === this._displayName) { return; }

        this._displayName = value;
        this.dispatchChangedEvent();
    }

    constructor(item: ISelectItem<T>, fnOnchange: () => any = null)
    {
        if (!item) { return; }

        this._itemId = item.ItemId;
        this._item = item.Item;
        this._displayName = item.DisplayName;

        if (fnOnchange) { this.OnChanged(fnOnchange); }
    }

    private dispatchChangedEvent(): void
    {
        this._eventTarget.dispatchEvent(new cc.Event.EventCustom(SelectItemData.OnChangedEventName, false));
    }
}
